import actions from "../../constants/actions";

const initialState = {
    user: null,
    isLoading: false,
    isUpdating: false,
    isDeleting: false,
    isLoggingIn: false,
    isRegistering: false,
    isRecovering: false,
    isResetting: false,
    isUpdating: false,
    error: null,
};

export default function app(state = initialState, action) {
    switch (action.type) {
        case actions.LOAD_USER_ME:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case actions.LOGIN:
            return {
                ...state,
                isLoggingIn: true,
                error: null,
            };
        case actions.REGISTER:
            return {
                ...state,
                isRegistering: true,
                error: null,
            };
        case actions.LOGIN_SUCCESS:
        case actions.LOAD_USER_ME_SUCCESS:
            return {
                ...state,
                user: action.payload.result.data,
                isLoading: false,
                isLoggingIn: false,
                isRegistering: false,
                error: null,
            };
        case actions.REGISTER_SUCCESS:
            return {
                ...state,
                user: null,
                isLoading: false,
                isLoggingIn: false,
                isRegistering: false,
                error: null,
            };
        case actions.LOGIN_FAIL:
        case actions.LOAD_USER_ME_FAIL:
        case actions.REGISTER_FAIL:
            return {
                ...state,
                isLoading: false,
                isLoggingIn: false,
                isRegistering: false,
                error: action.payload,
            };
        case actions.RECOVER:
            return {
                ...state,
                isRecovering: true,
            };
        case actions.RECOVER_SUCCESS:
            return {
                ...state,
                isRecovering: false,
                error: null,
            };
        case actions.RECOVER_FAIL:
            return {
                ...state,
                isRecovering: false,
                error: action.payload,
            };
        case actions.RESET:
            return {
                ...state,
                isResetting: true,
            };
        case actions.RESET_SUCCESS:
            return {
                ...state,
                isResetting: false,
                error: null,
            };
        case actions.RESET_FAIL:
            return {
                ...state,
                isResetting: false,
                error: action.payload,
            };
        case actions.UPDATE_USER_ME:
            return {
                ...state,
                isUpdating: true,
            };
        case actions.UPDATE_USER_ME_SUCCESS:
            return {
                ...state,
                isUpdating: false,
                error: null,
            };
        case actions.UPDATE_USER_ME_FAIL:
            return {
                ...state,
                isUpdating: false,
                error: action.payload,
            };
        case actions.DELETE_USER_ME:
            return {
                ...state,
                isDeleting: true,
            };
        case actions.DELETE_USER_ME_SUCCESS:
            return initialState;
        case actions.DELETE_USER_ME_FAIL:
            return {
                ...state,
                isDeleting: false,
                error: action.payload,
            };
        case actions.LOGOUT_SUCCESS:
            return initialState;
        default:
            return state;
    }
}
